import Env from "../base/env";
import gsap from "gsap";
import Cookies from "js-cookie";

export default class Announcement {
  constructor() {
    this.DOM = {
      view: document.querySelector("annoucement-bar"),
      close: document.getElementById("close-annoucement"),
    };
    this.VARS = {
      nameCookie: "announcement_bar_hidden",
    };

    if (this.DOM.view != null) {
      this.detect();
      this.launch();
    }
  }

  create() {
    const oneHour = new Date(new Date().getTime() + 60 * 60 * 1000);
    Cookies.set(this.VARS.nameCookie, 1, {
      expires: oneHour,
    });
  }

  detect() {
    if (Cookies.get(this.VARS.nameCookie) == 1) {
      this.DOM.view.classList.add("hide");
    } else {
      Env.$html.classList.add("with-announcement");
    }
  }

  launch() {
    gsap.delayedCall(0.6, () => {
      this.DOM.close.addEventListener("click", () => {
        this.create();
        Env.$html.classList.remove("with-announcement");
        this.DOM.view.classList.add("hide");
        gsap.delayedCall(1, () => {
          this.DOM.view.parentElement.removeChild(this.DOM.view);
        });
      });
    });
  }
}
